module.exports = "data:text/x-markdown;base64,QXMgdGhlIHByZXZpb3VzIGxldmVsLCBgZGVsZWdhdGVgIG1lbnRpb25zLCB0aGUgdXNlIG9mIGBkZWxlZ2F0ZWNhbGxgIHRvIGNhbGwKbGlicmFyaWVzIGNhbiBiZSByaXNreS4gVGhpcyBpcyBwYXJ0aWN1bGFybHkgdHJ1ZSBmb3IgY29udHJhY3QgImxpYnJhcmllcyIgdGhhdApoYXZlIHRoZWlyIG93biBzdGF0ZS4gVGhpcyBleGFtcGxlIGRlbW9uc3RyYXRlcyB3aHkgdGhlIGBsaWJyYXJ5YCBrZXl3b3JkCnNob3VsZCBiZSB1c2VkIGZvciBidWlsZGluZyBsaWJyYXJpZXMsIGFzIGl0IHByZXZlbnRzIHRoZSBsaWJyYXJpZXMgZnJvbQpzdG9yaW5nIGFuZCBhY2Nlc3Npbmcgc3RhdGUgdmFyaWFibGVzLiAKCg=="


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/preservation_complete.md
// module id = 1398
// module chunks = 0